import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import '../../styles.css';

import { Button } from '@components';

import { Cronometro } from '../Cronometro';

import { APIAutenticacao } from '../../../../common/services/autenticacao';

import { setRecuperacaoSenhaDados } from '../../../../store/configs/slice';

export const InsereToken = () => {
  const dadosUsuario =
    useSelector((state) => state.configs.recuperacaoSenha) ?? {};
  const situacaoTimmer = useSelector(
    (state) => state.configs.temporizador?.situacao
  );
  const dispatch = useDispatch();

  const [tokenInvalido, setTokenInvalido] = useState('');
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [field1, setField1] = useState('');
  const [field2, setField2] = useState('');
  const [field3, setField3] = useState('');
  const [field4, setField4] = useState('');
  const [field5, setField5] = useState('');
  const [field6, setField6] = useState('');
  const [contaField, setContaFiedl] = useState(0);

  useEffect(() => {
    if (situacaoTimmer === 'finalizado') {
      const params = {
        email: undefined,
        telefone: undefined,
        matricula: undefined,
        token: undefined,
        etapa: '1',
      };
      dispatch(setRecuperacaoSenhaDados(params));
    }
  }, [situacaoTimmer, dispatch]);

  useEffect(() => {
    if (contaField >= 6) setBtnDisabled(false);
  }, [contaField]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const inputToken = field1 + field2 + field3 + field4 + field5 + field6;

    const ativacaoSessao = await APIAutenticacao.ativaSessao(
      dadosUsuario.matricula,
      inputToken
    );

    if (ativacaoSessao) {
      const params = {
        email: dadosUsuario.email,
        telefone: dadosUsuario.telefone,
        matricula: dadosUsuario.matricula,
        token: inputToken,
        etapa: '3',
      };
      dispatch(setRecuperacaoSenhaDados(params));
      return;
    }

    setTokenInvalido('O token digitado é inválido!');
    setField1('');
    setField2('');
    setField3('');
    setField4('');
    setField5('');
    setField6('');
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    const [, fieldIndex] = name.split('-');
    setContaFiedl(contaField + 1);

    if (name === 'field-1') setField1(value);
    else if (name === 'field-2') setField2(value);
    else if (name === 'field-3') setField3(value);
    else if (name === 'field-4') setField4(value);
    else if (name === 'field-5') setField5(value);
    else setField6(value);

    const fieldIntIndex = parseInt(fieldIndex, 10);

    if (fieldIntIndex < 6) {
      const nextfield = document.querySelector(
        `input[name=field-${fieldIntIndex + 1}]`
      );

      if (nextfield !== null) {
        nextfield.focus();
      }
    }
  };

  return (
    <>
      {dadosUsuario.telefone || dadosUsuario.email ? (
        <>
          <p className="d-block align-items-center">
            Uma mensagem contendo um token de validação foi enviada para o(s)
            seguinte(s) contato(s):
            <ul className="primary-color">
              {dadosUsuario.telefone && (
                <li>
                  <span className="text-orange fw-bold">
                    {dadosUsuario.telefone}
                  </span>
                </li>
              )}
              {dadosUsuario.email && (
                <li>
                  <span className="text-orange fw-bold">
                    {dadosUsuario.email}
                  </span>
                </li>
              )}
            </ul>
          </p>
          <p className="mt-5">
            Por favor, digite abaixo o número de seis dígitos recebido:
          </p>
        </>
      ) : (
        <p className="d-block align-items-center">
          Entre em contato com a Forluz através do telefone 0800 - 090 9090 e
          informe que deseja recuperar a sua senha. <br />
          <br /> O(A) atendente informará um token de seis dígitos que deverá
          ser preenchido no campo abaixo.
        </p>
      )}

      <form onSubmit={handleSubmit}>
        <div className="row mt-32 container-token">
          <input
            name="field-1"
            min={1}
            max={9}
            className="input"
            required
            type="number"
            value={field1}
            onChange={handleChange}
          />

          <input
            name="field-2"
            className="input"
            required
            type="number"
            value={field2}
            onChange={handleChange}
          />

          <input
            name="field-3"
            className="input"
            required
            type="number"
            value={field3}
            onChange={handleChange}
          />

          <input
            name="field-4"
            className="input"
            required
            type="number"
            value={field4}
            onChange={handleChange}
          />

          <input
            name="field-5"
            className="input"
            required
            type="number"
            value={field5}
            onChange={handleChange}
          />

          <input
            name="field-6"
            className="input"
            required
            type="number"
            value={field6}
            onChange={handleChange}
          />

          <p className="d-block text-center mb-3 mt-2 ts-14 fw-bold text-red">
            {tokenInvalido}
          </p>
          <Button
            className="mt-14 ts-14"
            large
            type="submit"
            disabled={btnDisabled}
          >
            Enviar
          </Button>

          {dadosUsuario.telefone && dadosUsuario.email && (
            <p className="d-block text-center mt-32 ts-14 fw-bold text-orange">
              Tempo restante:
              <Cronometro tempoAtual="00:05:00" tempoTotal={300} />
            </p>
          )}
        </div>
      </form>
    </>
  );
};
